<template lang="pug">
  div
    component(
      :is="avatarComponent(inList)"
      :color="color"
      :size="size"
    )
      slot
        span(
          v-if="displayText"
          :class="textClasses"
          :style="textStyles"
        ) {{ displayText }}
        v-icon.liondesk-avatar-icon(
          v-else
          :class="textClasses"
          :style="textStyles"
        ) person
</template>
<script>
import { undefinedNamePlaceholder } from '../config/placeholderConstants';

export default {
  name: 'LiondeskAvatar',

  data() {
    return {
      // The actual text intended to be displayed, which might be different
      // than the prop
      displayText: '',
    };
  },

  props: {
    // Whether the avatar is in a list or not, at which we must use
    // v-list-tile-avatar instead of v-avatar
    inList: Boolean,
    // The intended color of the avatar
    color: String,
    // The intended size of the avatar
    size: [String, Number],
    // The custom classes of the desired avatar content
    textClasses: String,
    // The custom styles of the desired avatar content
    textStyles: String,
    // The text supplied to the avatar, gives way to a template slot if given
    text: String,
  },

  mounted() {
    this.setDisplayText(this.text);
  },

  watch: {
    // Detect any changes in the prop
    text(value) {
      this.setDisplayText(value);
    },
  },

  methods: {
    // Assigns the display text if the given value is neither empty nor
    // the placeholder value
    setDisplayText(value) {
      if (value && value !== undefinedNamePlaceholder) {
        this.displayText = value;
      } else {
        this.displayText = '';
      }
    },
    // Returns the correct avatar component if it is in a list or not
    avatarComponent(isAvatarInList) {
      return isAvatarInList ? 'v-list-tile-avatar' : 'v-avatar';
    },
  },
};
</script>
<style lang="scss" scoped>
.liondesk-avatar-icon {
  // This css class is required because some vuetify classes assigns a new
  // font family. Icons cannot work with font families other than 'Material Icons'
  // It would render the text instead of the actual icon
  font-family: 'Material Icons' !important;
};
</style>
